import { render, staticRenderFns } from "./finalizado.vue?vue&type=template&id=f1010142&scoped=true&"
import script from "./finalizado.vue?vue&type=script&lang=js&"
export * from "./finalizado.vue?vue&type=script&lang=js&"
import style0 from "./finalizado.vue?vue&type=style&index=0&id=f1010142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1010142",
  null
  
)

export default component.exports